export const validSiret = new RegExp(/^\d{14}$/)